module.exports = __webpack_public_path__ + "static/media/grinning-face-with-smiling-eyes.b5cca853.svg";